import { map } from 'ramda';
import { QColorsQuery } from '../_graphql/queries/documents/QColors';
import useFetchQuery from './useFetchQuery';

const useColors = (env) => {
  const { colors: teamColors, isLoading } = useFetchQuery({
    query: QColorsQuery,
    dataProp: 'colors',
    defaultData: [],
    env
  });

  const colors = map(({ name, value, uuid }) => ({
    color: value, title: name, uuid
  }))(teamColors);

  return { colors, isLoading };
};

export default useColors;
